export const dashboard = "dashboard";
export const register = "register";
export const affiliatesAgency = "affiliatesAgency";
export const createAccount = "create-account";
export const documentUpload = "document-upload";
